/**
 * Created by anthony on 1/29/15.
 */
applicationsSubNavbar.classy.controller({
    name: 'ArchiveModalController',
    inject: ['$scope', '$modalInstance', 'ApplicationService', 'StandardModalCudFactory', 'AppModelService', '$state', '$timeout'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.ApplicationService  = this.ApplicationService;
        this.$.year = this.ApplicationService.getAwardData().app[0].App_Fin_Year;
        this.item = {};
        this.item.App_Fin_Year = this.$.year - 1;
        this.$.item = this.item;
        this.$.modalCud = new this.StandardModalCudFactory(this.AppModelService,
            this.ApplicationService.getAwardData().app[0].applicationID, this.item, this, [], this.index, this.$modalInstance);
        this.$.modalCud.setAlwaysPut(true);
    },
    archiveComplete: function()
    {
        var parent = this;
        this.$state.transitionTo('schoolside.archive', {applicationID: this.ApplicationService.getAwardData().app[0].applicationID}).then(function() {
            parent.$timeout(function() {
                parent.$modalInstance.dismiss()
            }, 1000);
        });
    }
});